import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
export default {
  components: {
    PageNavBackLayoutCpt
  },
  date() {
    return {
      show: false
    };
  },
  mounted() {}
};